// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"RecipeBakeSection_wrapper__P5Z_m","tableWrapper":"RecipeBakeSection_tableWrapper__kdZuY","richText":"RecipeBakeSection_richText__mR_6c"};